interface Bundle {
    bundleKey: string;
    bundleValues: any;
}
interface DictionaryResponse {
    data: Bundle[];
}

export async function getDictionary(language: string, pageId: string) {
    try {
        const requestHeaders = new Headers();
        requestHeaders.append("Content-Type", "application/json");

        const requestOptions = {
          method: "GET", 
          headers: requestHeaders,
        };

        const response = await fetch(`/ab/api/atomic/${language}/translations?pageId=${pageId}`, requestOptions);
        return await response.json() as DictionaryResponse
    } catch (e) {
        console.error(e);
        throw new Error("Failed to retrieve dictionary data.");
    }
}